<template>
    <div>
        <BaseModal
            v-if="visible"
            ModalId="modalId"
            :HideModalFun="onHidden"
            :TitleWindow="$tc('userHeader.EmployeeDocumentTitle', this.editMode ? 1 : 2)"
            :width="'70%'"
            :height="'auto'"
            :buttons="[
                { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                {
                    text: $t('Shared.Save'),
                    variant: 'primary',
                    action: emitEventOK,
                    disabled: loading
                }
            ]"
            @Close="close"
        >
            <div id="container">
                <b-row>
                    <b-col class="col-md-3">
                        <MdSelect
                            v-bind:Label="$t('PatientDocument.DocumentType')"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Options="documentTypeList"
                            v-bind:Model="editableItem.doccode"
                            v-bind:isRequired="true"
                            v-bind:isValid="isDocumentTypeValid"
                            v-bind:Multiple="false"
                            :Input="changeDropDownDocument"
                            id="document_typesDetail_select"
                            v-bind:IsDisabled="editMode"
                        />
                    </b-col>
                    <b-col class="col-md-3">
                        <MdDateTime
                            :Label="$t('Shared.ExpirationDate')"
                            :Model="editableItem.expirationDate"
                            @input="editableItem.expirationDate = $event"
                            :Id="'PatientDocumentExpirationDate'"
                            :Type="'date'"
                            :isRequired="false"
                            :isConfirm="false"
                            :isValid="isValidDate"
                        >
                        </MdDateTime>
                    </b-col>
                    <b-col class="col-md-6">
                        <MdEdit
                            v-bind:Label="$t('Shared.Comments')"
                            v-bind:TypeProp="'text'"
                            v-bind:Name="'comments'"
                            v-model="editableItem.comments"
                            v-bind:Id="'comments'"
                        >
                        </MdEdit>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col class="col-12" style="overflow-y: auto;">
                        <LoadDocument
                            v-bind:Records="files"
                            v-bind:ModeEdit="editMode"
                            v-bind:DocType="editableItem.description"
                            v-bind:DocCode="editableItem.code"
                            v-bind:UserId="UserId"
                            v-bind:DocumentTypeList="documentTypeList"
                            v-bind:EntityType="'E'"
                            @UpdateFiles="OnUpdateDocumentFile($event)"
                            @start-drag-and-drop="loading = true"
                            @end-drag-and-drop="loading = false"
                        />
                    </b-col>
                </b-row>
            </div>
        </BaseModal>
    </div>
</template>

<script>
import validationMixin from '@/common/validationMixin';
import validationRules from '@/common/validationRules';
import ShowMessage from '@/components/messages/ShowMessage.js';
import LocalStorage from '@/services/storage.service';

export default {
    name: 'EmployeeDocumentMgrModal',
    mixins: [validationMixin, ShowMessage],
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        value: {
            type: Object,
            required: true
        },
        documentTypeList: {
            type: Array,
            required: true
        },
        editMode: {
            type: Boolean,
            default: false
        }
    },

    data() {
        const cloneItem = { ...this.value };
        return {
            modalId: 'EmployeeDocumentMgrModal',
            emitCloseEvent: false,
            editableItem: cloneItem,
            files: this.editMode ? [cloneItem] : [],
            isDocumentTypeValid: true,
            isValidDate: true,
            UserId: LocalStorage.getUserId(),
            loading: false
        };
    },

    watch: {
        visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent = true;
            }
        },
        value(newVal) {
            this.isDocumentTypeValid = true;
            this.isValidDate = true;
            this.editableItem = { ...newVal };
            this.files = this.editMode ? [this.editableItem] : [];
        }
    },

    methods: {
        emitEventCancel() {
            this.emitCloseEvent = false;
            this.$emit('update:visible', false);
        },

        emitEventOK(bvModalEvent) {
            if (this.loading) {
                bvModalEvent.preventDefault();
                return;
            }

            if (this.validate()) {
                this.$emit('update:visible', false);

                this.files.forEach(document => {
                    (document.expirationDate = this.editableItem.expirationDate),
                        (document.doccode = this.editableItem.doccode),
                        (document.comments = this.editableItem.comments),
                        (document.description = this.editableItem.description);
                });
                this.$emit('ok', this.files);
            } else {
                bvModalEvent.preventDefault();

                this.isDocumentTypeValid = this.isValid('doccode');
                this.isValidDate = this.isValid('expirationDate');
            }
        },

        onHidden() {
            if (this.emitCloseEvent) {
                this.$emit('update:visible', false);
                this.emitCloseEvent = false;
            }
        },

        close() {
            this.emitEventCancel();
        },

        validate() {
            const rules = {
                doccode: [validationRules.required(this.$t('Msg.CheckRequiredFields'))],
                expirationDate: [validationRules.date(null, this.$t('Shared.InvalidDate'))]
            };

            return this.validateFields(rules, this.editableItem);
        },

        changeDropDownDocument(value) {
            this.editableItem.doccode = value ? value.code : '';
            this.editableItem.description = value ? value.description : '';
        },

        OnUpdateDocumentFile(file) {
            this.files = file;
        }
    }
};
</script>

<style scoped>
.fileDropArea {
    height: calc(70vh - 224px) !important;
}
</style>
